import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
//import hash from 'object-hash'
import useInterval from '@use-it/interval'
import RabbitMqConnection from './push_notifications/rabbit_mq_connection';
import PusherConnection from './push_notifications/pusher_connection';
import NatsConnection from './push_notifications/nats_connection';
import AblyConnection from './push_notifications/ably_connection';
import InternetCheck from './push_notifications/internet_check';

export function setWindowConnectionState(key, value) {
  console.log("setWindowConnectionState", key, value)
    if(!window.flaveConnectionStates) {
      window.flaveConnectionStates = {}
    }
    window.flaveConnectionStates[key] = value
}

export default function WebsocketConnection({ channels, onReceive, ...props}) {
  const dispatch = useDispatch()
  const [receivedMessageCounts, setReceivedMessageCounts] = useState({ably: 0, pusher: 0})

  const stateChannels = useSelector(state => (state.websocket?.channels || []).concat(channels ? channels : []), shallowEqual)

  //const [dispatchedMessages] = useState({})

  useEffect(() => {
    if(!window.dispatchedMessages) {
      window.dispatchedMessages = {}
    }
  }, [])

  const dispatchMessage = (value) => {
    console.log({onReceive})
    onReceive ? onReceive(value) : dispatch(value)
  }

  const onMessageCompleted = (source, messageId, value) => {
    console.log("Received via", source, {value})

    if(!messageId) {
      dispatchMessage(value)
      console.log("Dispatched via ", source, {value})
      return true
    }

    if(!window.dispatchedMessages[messageId]) {
      dispatchMessage(value)
      console.log("Dispatched via ", source, {value})
      window.dispatchedMessages[messageId] = true
      return true
    } 

     console.log("Already dispatched (" + source + " too late)", messageId)
  }

  return <div className="connectionStatus" style={{
        position: "fixed",
        left: 5,
        bottom: 5,
        zIndex: 9999999,
      }}>
      <style>{`
        .network-status {
          display: inline-block;
          border-radius: 3px;
          padding: 2px 6px;
          font-size: 7pt;
        }
        .network-status-success { background-color: green; }
        .network-status-danger { background-color: red; }
        .network-status-warning { background-color: orange; }
        `}
      </style>
      { window.location.host != "localhost:3000" &&
        <>
          <i className="fa fa-wifi fa-fw"></i>
          <style>
            {`
              .connectionStatus .details {
                display:none;
              }
              .connectionStatus:hover .details {
                display:inline-block;
                margin-left: 5px;
              }
            `}
          </style>
        </>
      }

    <div className="details">
      <InternetCheck/>
      {" "}
      <PusherConnection onMessageCompleted={onMessageCompleted} channels={stateChannels} {...props}/>
      {" "}
      <RabbitMqConnection onMessageCompleted={onMessageCompleted} channels={stateChannels} {...props}/>
      {" "}
      <AblyConnection onMessageCompleted={onMessageCompleted} channels={stateChannels} {...props}/>
      {" "}
      <NatsConnection onMessageCompleted={onMessageCompleted} channels={stateChannels} {...props}/>
    </div>
  </div>
}
